import URLSearchParams from 'url-search-params';

export function baiduTrackEvent(name, action, desc) {
  if (window._hmt && _.isFunction(window._hmt.push)) {
    window._hmt.push(['_trackEvent', name, action, desc]);
  } else {
    console.log('window._hmt 没有加载成功');
  }
}

// 格式化URL查询参数至对象
// export function formatUrlQuery(str) {
//   let obj = {};
//   if (str) {
//     let strQueryArr = str.slice(1).split('&');
//     strQueryArr.forEach(item => {
//       let config = item.split('=');
//       obj[config[0]] = Base64.decode(config[1]);
//     });
//   }
//   return obj;
// }

// 格式化URL查询参数至对象
export function sum(a, b) {
  return a + b;
}

// PC 访问金融首页
export const ueAddPageJR = 1;
// FS 访问金融首页
export const ueAddPageFSJR = 5;

export function UeAddParams() {
  if (isFS()) {
    let deviceInfoStr = window.keruyun.devicesInfo() || '{}';
    return convertFSParams(JSON.parse(deviceInfoStr));
  } else if (isBUI()) {
    let searchParams = new URLSearchParams(window.location.search);
    return {
      jwt: searchParams.get('jwt'),
    };
  } else {
    return {};
  }
}

export function isBUI() {
  let searchParams = new URLSearchParams(window.location.search);
  return searchParams.has('jwt');
}

export function isFS() {
  if (
    typeof window.keruyun !== 'undefined' &&
    typeof window.keruyun.devicesInfo === 'function'
  ) {
    return true;
  } else {
    return false;
  }
}

function convertFSParams(obj) {
  return {
    commercialId: Number(obj.commercialId),
    path: window.location.pathname,
    page: ueAddPageFSJR,
    type: 1,
    userName: obj.userName,
    // 品牌号
    brandId: obj.brandId,
    referrer: obj.referrer,
    // 登录客户端的手机号码
    commercialCellPhone: obj.commercialCellPhone,
    deviceType: obj.deviceType === 'android' ? '2' : '',
    // 设备标识
    deviceId: obj.deviceId,
    // 设备类型
    model: obj.model,
    // 用户编号
    userId: obj.userId,
    // 应用版本号
    versionCode: obj.versionCode,
    // 设备版本
    systemVersion: obj.systemVersion,
    version: obj.version,
    appType: obj.appType,
  };
}



// WEBPACK FOOTER //
// ./src/shared/utils/commonUtil.js